export interface ExerciseProgress {
  pageId?: string;
  exerciseId?: string;
  type?: 'GAP_FILL' | 'SHORT_ANSWER' | 'MULTIPLE_CHOICE' | 'SUMMARY_COMPLETION_WITH_HINT' | 'QUIZ';
  userAnswers?: UserAnswer[];
  isCompleted?: boolean;
}

export interface UserAnswer {
  questionId?: string;
  answer?: string;
  answerIds?: string[];
}

export const EXERCISES_LOCAL_STORAGE_KEY = 'exercises_local';
